import { z } from "zod";

export const BoardStatusSchema = z.enum(["active", "archived"]);
export type BoardStatus = z.infer<typeof BoardStatusSchema>;

export const BoardSummarySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  status: BoardStatusSchema,
  ownerId: z.string(),
  updatedAt: z.string().datetime(),
});
export type BoardSummary = z.infer<typeof BoardSummarySchema>;
